import { Node } from '@tiptap/core'
import { TextSelection } from '@tiptap/pm/state'
import { sharedAttrs } from '../shared/shared-attrs'

export const AttendeeList = Node.create({
  name: 'attendee_list',
  content: 'paragraph bulletList*',
  defining: true,

  addAttributes() {
    return { ...this.parent?.(), ...sharedAttrs }
  },

  parseHTML() {
    return [{ tag: 'div[data-type="attendee-list"]' }]
  },

  renderHTML({ HTMLAttributes }) {
    return ['div', { ...HTMLAttributes, 'data-type': 'attendee-list' }, 0]
  },

  addKeyboardShortcuts() {
    return {
      Backspace: ({ editor }) => {
        if (!editor.isActive('attendee_list')) {
          return false
        }

        const selection = editor.state.selection
        if (selection instanceof TextSelection && selection.$cursor !== null && selection.$cursor.parentOffset === 0) {
          const depth = selection.$cursor.depth
          const parentNode = selection.$cursor.node(depth - 1)

          if (parentNode.type.name === 'attendee_list' && parentNode.firstChild === selection.$cursor.parent) {
            return true
          }
        }

        return false
      },
    }
  },
})
